/** Compares the properties on two objects to see if they are different */
export const isDifferent = (propertyList, firstObject, secondObject) =>
	propertyList.some((prop) => firstObject[prop] !== secondObject[prop]);

export const mapDreForStore = (arr) => {
	const dre = {};
	/* eslint-disable no-plusplus */
	for (let i = 0; i < arr.length; i++) {
		const { disclaimerId, licenseNumber } = arr[i];
		dre[disclaimerId] = licenseNumber;
	}
	return dre;
};

export const mapDreForSave = (obj) => {
	const arr = [];
	Object.entries(obj).forEach(([key, val]) => {
		const entry = {};
		entry.disclaimerId = key;
		entry.licenseNumber = val;
		arr.push(entry);
	});

	return arr;
};
